import angular from 'angular'
import findReplace from './findReplace.component'

export default angular
  .module('ellipsis.findReplace', [])
  .component('findReplace', findReplace)
